<template>
  <div>
    <v-head></v-head>
    <div class="more_bg">
      <img src="../assets/pic02.png" alt="">
      <div class="more_txt">
        <div class="title">
           智能AI
        </div>
        <div class="txt">
          Intelligent AI
        </div>
      </div>
    </div>
    <div class="more_content">
      <div class="more_left">
        <img src="../assets/pic31.png" alt="">
      </div>
      <div class="more_right">
        <div class="maxTitle">智能运维视频辅助巡检机器人</div>
        <div class="more_wrap">
          <div class="title">产品介绍</div>
          <div class="txt">
            智能运维视频辅助装置是一种工作在无人变电站环境下，具备室内定位和机器视觉识别功能的履带机器人，通过电力变压器监控图像自主分析和变化趋势激励分析，
            实现变电站变压器渗油、变压器六氟化硫指示器自动识别和现场环境火警、烟雾、积水状况判别等功能，实现智能巡检应用。系统采用基于动态递归神经网络的变
            电站视频图像自动分析方法，可以自主识别设备、环境异常，显著提高自主无人巡检的自动化水平。
            通过广泛调研和试验验证，本产品针对基于巡检图像识别技术的智能运维视频辅助装置提出了一套可行的履带式移动
            机器人结构设计方案和一套高性能网络通信框架，能够高效的实现设备状态识别和环境异常监测，所提出的方案极大扩展了智能巡检系统的巡检作业能力，
            具备一定的市场推广价值，对促进变电站安全稳定运行，提高供电可靠性具有重要意义，其应用前景广阔。
          </div>
          <div class="title">相关案例</div>
          <img src='../assets/pic3.png' alt="" @click="gotoDetail">
          <div class="txt last">智能运维视频辅助巡检机器人</div>
        </div>
      </div>
    </div>
    <div class="more_detail">
      <div class="title_wrap">
        <div class="title">
          产品详情
        </div>
        <div class="mini_title">
          DETAILS
        </div>
      </div>
      <div class="box">
        <div class="more_top">
          <div class="more_list begin">
            <div class="title">创新的系统设计</div>
            <div class="en">Innovative system design</div>
            <div class="txt"><span class="el-icon-caret-right"></span>整套系统采用模块化设计，易于安装配置，操作流
              程的设计安全规范且简单易懂。整套装置可长时间
              稳定运行，巡检准确率高，能有效提高变电站巡检
              效率，减少巡检人力投入，降低巡检成本。</div>
            
          </div> 
          <div class="more_list begin">
            <div class="title">丰富的传感器数据</div>
            <div class="en">Rich sensor data</div>
            <div class="txt"><span class="el-icon-caret-right"></span>巡检装置搭载多种传感器，可一次性完成设备仪表
              数据采集、环境（烟雾、火焰、氧气含量）检测、
              基于热红外传感器检测设备温度、变压器漏油检测
              等多种巡检任务，可发现人工巡检难以察觉的设备
              异常。</div>
          </div>
          
          <div class="more_list end begin">
            <div class="title">高效准确的循迹策略</div>
            <div class="en">Efficient and accurate tracking strategy</div>
            <div class="txt"><span class="el-icon-caret-right"></span>研发了一种基于红外线反射特性和图像处理的室内
              循迹策略，可实现智能运维装置在室内变电站的精
              确循迹和定位。</div>
          </div>
          
        </div>
        <div class="more_top">
          <div class="more_list">
            <div class="title">创新的图像识别程序</div>
            <div class="en">Innovative image recognition program</div>
            <div class="txt"><span class="el-icon-caret-right"></span>基于OpenCV开发了变电站设备图像处理程序，可
              从设备的可见光图像和红外图像中提取出仪表数据、
              呼吸器状态、环境烟雾火焰状态、变压器漏油状态
              等信息，处理速度快，提取信息准确。</div>
            
          </div> 
          <div class="more_list">
            <div class="title">多种环境数据获取方式</div>
            <div class="en">Multiple environmental data acquisition methods</div>
            <div class="txt"><span class="el-icon-caret-right"></span>不同于单一的环境检测策略，智能运维设备对环境
              数据的获取采用了基于图像处理获取数据和基于传
              感器获取数据两种方式，并结合两种来源的数据综
              合判断变电站环境（烟雾、火焰），提高巡检准确
              率。</div>
          </div>
          
          <div class="more_list end">
            <div class="title">稳定高效的运动控制</div>
            <div class="en">Stable and efficient motion control</div>
            <div class="txt"><span class="el-icon-caret-right"></span>运动控制是实现巡检任务的基础，本项目基于模糊
              PID理论设计智能运维设备的运动控制策略，环境
              适应性好，可实现智能运维设备的稳定可靠控制。</div>
          </div>
          
        </div>
        <div class="more_top end">
          <div class="more_list">
            <div class="title">无线通信网络</div>
            <div class="en">Wireless Communication Network</div>
            <div class="txt"><span class="el-icon-caret-right"></span>采用高性能无线路由器组建无线局域网，控制终端
              通过无线通讯方式访问智能运维设备搭载的高清摄
              像头、获取巡检数据信息，无线高清摄像头实时画
              面分辨率可达1920x1080。</div>
          </div> 
          <div class="more_list">
            <div class="title">灵活可配置的传感器方案</div>
            <div class="en">Flexible and configurable sensor solutions</div>
            <div class="txt"><span class="el-icon-caret-right"></span>智能运维设备设计了丰富的传感器接口，可根据不
              同巡检场所的需求灵活配置相应的传感器组合，软
              件系统中设计了不同的传感器处理模块，可适应不
              同的传感器组合方案。</div>
          </div> 
        </div>
      </div>
    </div>
    <div class="more_down">
      <div class="title_wrap">
        <div class="title">
          相关下载
        </div>
        <div class="mini_title">
          DOWNLOAD
        </div>
      </div>
      <div>
        <img src="../assets/code.png" alt="">
      </div>
    </div>
    <v-foot class="more_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    },
    gotoDetail() {
      router.push('/detail6')
    }
  }
}
</script>
<style scoped>

.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.more_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.more_txt {
  position: absolute;
  top: 260px;
  right: 420px;
  color: #fff ;
}
.more_txt .title {
  font-size: 58px;
}
.more_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.more_text {
  display: flex;
}

.more_content {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 70%;
  align-items: center;
  margin: 0 auto;
  padding-top: 80px;
}
.more_left img{
  width: 420px;
  height: 360px;
}
.more_right {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 50px;
}
.more_right img {
  width: 210px;
  height: 120px;
}
.more_right .maxTitle {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}
.more_right .title {
  margin: 15px 0;
  font-size: 22px;
  color: #333;
  font-weight: 600;
}
.more_right .txt {
  font-size: 15px;
  color: #333;
}
.more_wrap {
  width: 550px;
  border-top: 1px solid #333;
  margin: 15px 0;
}
.more_wrap .last {
  margin-top: 10px;
}
.more_detail {
  width: 1000px;
  margin: 0 auto;
}
.more_detail .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
}
.more_detail .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_detail .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_detail .more_top {
  display: flex;
}
.more_top .more_list {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 300px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px 10px;

}
.end .more_list {
  width: 280px;
  padding: 20px 10px;
  margin-top: 50px;
}
.more_detail .end {
  margin-right: 0;
}
.more_detail .begin {
  margin-bottom: 50px;
}
.more_detail .more_list .title {
  font-size: 18px;
  font-weight: 600;
}
.more_detail .more_list .en {
  font-size: 14px;
  padding: 10px 0;
  color: #bbb;
}
.more_detail .more_list .txt {
  font-size: 14px;
  color: #333;
  display: flex;
}
.el-icon-caret-right {
  margin-top: 5px;
  color: #333;
}
.more_detail .more_bottom {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 280px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 30px;
  padding: 30px 10px;


}
.more_down {
  width: 1000px;
  margin: 0 auto;
}
.more_down .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
  margin-top: 60px;
}
.more_down .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_down .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_foot {
  margin-top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/MoreInfor5.vue